import Poll from "../components/Poll";
export default function ManualPoll(props) {
  return <Poll showSnack={props.showSnack} />;
}
